import Vue from 'vue'
import Router from 'vue-router'
//import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      component: () => import('../views/login/Login'),
      meta: {
        title: '登录',
        requireLogin: false
      }
    },
    // {
    //   path: '/loginout',
    //   component: () => import('../views/login/Loginout'),
    //   meta: {
    //     title: '未登录提示',
    //     requireLogin: false
    //   }
    // },
    {
      path: '/sso',
      component: () => import('../views/login/Sso'),
      meta: {
        title: 'SSO',
      }
    },
    {
      path: '/sorry',
      component: () => import('../views/login/Sorry'),
      meta: {
        title: 'Sorry',
      }
    },
    // 改版路由 yxj 2024.06.17
    {
      name: 'Index',
      path: '/',
      component: () => import('../views/index/Index'),
      meta: {
        title: '首页',
        requireLogin: false
      }
    },
    {
      name: 'OrderLists',
      path: '/order/order_lists',
      component: () => import('../views/order/OrderLists'),
      meta: {
        title: '订单列表',
        requireLogin: true,
      }
    },
    // 交付检点
    {
      name: 'DeliveryLists',
      path: '/order/delivery_lists',
      component: () => import('../views/order/DeliveryLists'),
      meta: {
        title: '订单列表',
        requireLogin: true,
        keepAlive: true
      }
    },
    {
      name: 'DeliveryDetail',
      path: '/order/delivery_detail',
      component: () => import('../views/order/DeliveryDetail'),
      meta: {
        title: '订单详情',
        requireLogin: true,
      }
    },
    // 一级订单/总部订单
    {
      name: 'HeadAndClass',
      path: '/order/head_and_class',
      component: () => import('../views/order/HeadAndClass'),
      meta: {
        title: '订单列表',
        requireLogin: true,
        keepAlive: true
      }
    },









    //=================== 经销商
    // {
    //   name: 'OrderList',
    //   path: '/orderlist/:type',
    //   component: () => import('../views/order/OrderList'),
    //   meta: {
    //     //title: '订单列表',
    //     requireLogin: true,
    //   }
    // },
    // {
    //   path: '/orderlist',
    //   redirect: '/orderlist/over'
    // },

    {
      name: 'Order',
      path: '/order/:id',
      component: () => import('../views/order/Order'),
      meta: {
        title: '订单详情',
        requireLogin: true,
      }
    },

    {
      name: 'Setting',
      path: '/setting',
      component: () => import('../views/setting/Setting'),
      meta: {
        title: '设置',
        requireLogin: true,
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js